/* ============================================================
   F.G. EDWARDS — Journees poules COLLECTION : interactive tools
   Vanilla JS, no deps, no build. All collection-template behaviour
   lives here (loaded defer once by jp-collection-hero; each tool
   section also links it, and a window guard makes the extra loads a
   no-op). Every block no-ops safely when its section is absent.
   Handles:
     1. Egg rainbow  (#jp-rainbow) : click an egg -> smooth-scroll to
        the breed grid and filter it by that egg colour; anchor href
        stays as the no-JS fallback. GA4 jpc_rainbow_click {breed}.
     2. Breed grid filter chips (parallel-agent contract) :
        data-jpc-filter-egg / -care / -type / -reset toggle over
        cards data-jpc-card [data-egg|data-care|data-btype];
        [data-jpc-empty] shows when nothing matches.
     3. Flock quiz (#jp-quiz) : 3-question state machine + pickFlock
        ladder + per-result breed chips injected from an embedded
        map, count line from Q2, CTA highlights matched grid cards.
        GA4 jpc_quiz_start / jpc_quiz_complete {q1,q2,q3,flock}.
     4. Availability matrix links : data-jpc-matrix-link ->
        GA4 jpc_matrix_click.
   GA4 is always guarded behind a window.gtag check.
   ============================================================ */
(function () {
  'use strict';
  if (window.__jpCollection) return;
  window.__jpCollection = true;

  var GRID_ID = 'jp-breed-grid';

  function ga(name, params) {
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, params || {}); } catch (e) { /* noop */ }
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || ''); } catch (e) { return null; }
  }

  function scrollToEl(el) {
    if (!el || !el.getBoundingClientRect) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---------- 2. Breed grid filter (shared by chips + rainbow) ---------- */
  var gridFilter = { egg: null, care: null, type: null };

  function grid() { return document.getElementById(GRID_ID); }

  function syncChips() {
    var dims = ['egg', 'care', 'type'];
    dims.forEach(function (dim) {
      var attr = 'data-jpc-filter-' + dim;
      var chips = document.querySelectorAll('[' + attr + ']');
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute(attr) === gridFilter[dim] ? 'true' : 'false');
      });
    });
  }

  function applyGridFilter() {
    var g = grid();
    if (!g) return;
    var cards = g.querySelectorAll('[data-jpc-card]');
    var visible = 0;
    cards.forEach(function (card) {
      var okEgg = !gridFilter.egg || card.getAttribute('data-egg') === gridFilter.egg;
      var okCare = !gridFilter.care || card.getAttribute('data-care') === gridFilter.care;
      var okType = !gridFilter.type || card.getAttribute('data-btype') === gridFilter.type;
      var show = okEgg && okCare && okType;
      if (show) { card.removeAttribute('data-jpc-hidden'); visible++; }
      else { card.setAttribute('data-jpc-hidden', 'true'); }
    });
    var empty = g.querySelector('[data-jpc-empty]') || document.querySelector('[data-jpc-empty]');
    if (empty) empty.hidden = visible !== 0;
    syncChips();
  }

  function initGridFilters() {
    var chips = document.querySelectorAll('[data-jpc-filter-egg],[data-jpc-filter-care],[data-jpc-filter-type],[data-jpc-filter-reset]');
    if (!chips.length) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        clearQuizHighlight();
        if (chip.hasAttribute('data-jpc-filter-reset')) {
          gridFilter = { egg: null, care: null, type: null };
          applyGridFilter();
          return;
        }
        ['egg', 'care', 'type'].forEach(function (dim) {
          var attr = 'data-jpc-filter-' + dim;
          if (chip.hasAttribute(attr)) {
            var val = chip.getAttribute(attr);
            gridFilter[dim] = (gridFilter[dim] === val) ? null : val; /* toggle */
          }
        });
        applyGridFilter();
      });
    });
  }

  /* ---------- 1. Egg rainbow ---------- */
  function initRainbow() {
    var eggs = document.querySelectorAll('[data-jpc-rainbow]');
    if (!eggs.length) return;
    eggs.forEach(function (egg) {
      egg.addEventListener('click', function (e) {
        var breed = egg.getAttribute('data-breed-code') || '';
        var eggName = egg.getAttribute('data-egg') || '';
        ga('jpc_rainbow_click', { breed: breed });
        var g = grid();
        if (!g) return; /* no grid on page: let the anchor navigate to the PDP */
        e.preventDefault();
        clearQuizHighlight();
        gridFilter.egg = eggName || null;
        applyGridFilter();
        scrollToEl(g);
      });
    });
  }

  /* ---------- 3. Flock quiz ---------- */
  function pickFlock(a) {
    var q1 = a.q1;
    var q3 = a.q3;
    /* first match wins, top-down (mirrors the brief ladder) */
    if (q1 === 'couleurs' || q3 === 'couleurs') return { key: 'rainbow', breeds: ['AZUR', 'OLIVE', 'NOIRAN', 'LEGHORN'] };
    if (q3 === 'enfants' || q1 === 'premiere-fois') return { key: 'famille', breeds: ['PLYMOUTH', 'COLOMBIENNE', 'LOHMANN'] };
    if (q3 === 'rusticite') return { key: 'rustique', breeds: ['PLYMOUTH', 'COLOMBIENNE', 'SASSO'] };
    if (q1 === 'production' || q3 === 'quantite') return { key: 'production', breeds: ['LEGHORN', 'LOHMANN', 'AZUR'] };
    return { key: 'equilibre', breeds: ['LOHMANN', 'PLYMOUTH', 'OLIVE'] };
  }

  var quizFlock = null; /* breed codes of the current recommendation, for the CTA highlight */

  function clearQuizHighlight() {
    var g = grid();
    if (!g) return;
    g.removeAttribute('data-jpc-quiz-dim');
    g.querySelectorAll('[data-jpc-card].is-quiz-pick').forEach(function (c) { c.classList.remove('is-quiz-pick'); });
  }

  function highlightQuizCards(breeds, eggNames) {
    var g = grid();
    if (!g) return;
    var codes = {}; breeds.forEach(function (b) { codes[b] = true; });
    var eggs = {}; eggNames.forEach(function (n) { if (n) eggs[n] = true; });
    var hit = 0;
    g.querySelectorAll('[data-jpc-card]').forEach(function (card) {
      var code = card.getAttribute('data-breed-code');
      var egg = card.getAttribute('data-egg');
      var match = (code && codes[code]) || (egg && eggs[egg]);
      if (match) { card.classList.add('is-quiz-pick'); hit++; }
      else { card.classList.remove('is-quiz-pick'); }
    });
    if (hit) {
      g.setAttribute('data-jpc-quiz-dim', 'true');
      scrollToEl(g);
      setTimeout(clearQuizHighlight, 2600);
    } else {
      scrollToEl(g);
    }
  }

  function initQuiz() {
    var quiz = document.querySelector('[data-jpc-quiz]');
    if (!quiz) return;

    var steps = [].slice.call(quiz.querySelectorAll('[data-jpc-q]'));
    var resultWrap = quiz.querySelector('[data-jpc-quiz-result-wrap]');
    var panels = [].slice.call(quiz.querySelectorAll('[data-jpc-result]'));
    var bar = quiz.querySelector('[data-jpc-quiz-bar]');
    var countLabel = quiz.querySelector('[data-jpc-quiz-count]');
    var backBtn = quiz.querySelector('[data-jpc-quiz-back]');
    var live = quiz.querySelector('[data-jpc-quiz-live]');
    var map = parseJSON(quiz.querySelector('[data-jpc-quiz-map]')) || {};
    var feed = parseJSON(quiz.querySelector('[data-jpc-quiz-feed]')) || null;

    /* ---------- one-tap flock reservation ---------- */
    function fmtMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' $';
    }
    function qtyFor(q2) { return q2 === 'grande' ? 3 : q2 === 'moyenne' ? 2 : 1; }

    function quizAddItems(items) {
      return new Promise(function (resolve, reject) {
        if (!items || !items.length) { reject(new Error('empty')); return; }
        var body = { items: items };
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(document.activeElement);
        }
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 8000);
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { clearTimeout(timeout); return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || (res.data && res.data.status && res.data.status !== 200)) {
              throw new Error((res.data && (res.data.description || res.data.message)) || 'Erreur');
            }
            if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'jp-quiz' });
            }
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              if (typeof drawer.renderContents === 'function') drawer.renderContents(res.data);
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            resolve(res.data);
          })
          .catch(function (err) { clearTimeout(timeout); reject(err); });
      });
    }

    function renderQuizAtc(panel, breeds, q2) {
      var box = panel.querySelector('[data-jpc-quiz-atc]');
      if (!box) return;
      box.innerHTML = '';
      var per = qtyFor(q2);
      var buyable = [];
      var missing = [];
      breeds.forEach(function (code) {
        var e = map[code];
        if (!e) return;
        if (e.variants && e.variants.length) buyable.push(e);
        else missing.push(e.title || code);
      });
      if (!buyable.length) {
        box.hidden = false;
        box.innerHTML = '<p class="jpc-quiz__atc-note">Ces races reviennent en janvier 2027. Inscrivez-vous à la liste prioritaire sur leur page pour réserver avant tout le monde.</p>';
        return;
      }
      var pds = [];
      buyable.forEach(function (e) { e.variants.forEach(function (v) { if (v.pd) pds.push(v.pd); }); });
      pds.sort();
      var target = pds[0] || null;
      function candidates(e) {
        return e.variants.filter(function (v) { return !target || v.pd === target || !v.pd; });
      }
      var stores = [];
      buyable.forEach(function (e) {
        candidates(e).forEach(function (v) { if (stores.indexOf(v.store) < 0) stores.push(v.store); });
      });
      var chosen = stores[0];
      try {
        var saved = JSON.parse(localStorage.getItem('jp-event-selection') || 'null');
        if (saved && stores.indexOf(saved.store) >= 0) chosen = saved.store;
      } catch (e) { /* noop */ }

      function pick(e) {
        var cs = candidates(e);
        for (var i = 0; i < cs.length; i++) { if (cs[i].store === chosen) return cs[i]; }
        return cs[0];
      }
      function build() {
        var lines = buyable.map(pick).filter(Boolean);
        var label = lines[0] ? lines[0].label : '';
        var total = 0;
        lines.forEach(function (v) { total += (v.price || 0) * per; });
        var html = '';
        if (stores.length > 1) {
          html += '<div class="jpc-quiz__atc-stores">' + stores.map(function (s) {
            return '<button type="button" class="jpc-quiz__atc-store' + (s === chosen ? ' is-selected' : '') + '" data-jpc-atc-store="' + s.replace(/"/g, '&quot;') + '">' + s + '</button>';
          }).join('') + '</div>';
        }
        html += '<button type="button" class="jpc-btn jpc-btn--primary jpc-quiz__atc-btn" data-jpc-atc-go>' +
          'Tout réserver pour le ' + label + ' · ' + (per * lines.length) + ' poules · ' + fmtMoney(total) + '</button>';
        html += '<p class="jpc-quiz__atc-sub">Votre sac de moulée (obligatoire) est inclus si votre panier n’en contient pas déjà un.</p>';
        if (missing.length) {
          html += '<p class="jpc-quiz__atc-note">' + missing.join(', ') + ' : de retour en janvier 2027.</p>';
        }
        html += '<p class="jpc-quiz__atc-msg" data-jpc-atc-msg hidden></p>';
        box.innerHTML = html;
        box.hidden = false;
        box.querySelectorAll('[data-jpc-atc-store]').forEach(function (b) {
          b.addEventListener('click', function () { chosen = b.getAttribute('data-jpc-atc-store'); build(); });
        });
        var go = box.querySelector('[data-jpc-atc-go]');
        var msg = box.querySelector('[data-jpc-atc-msg]');
        if (go) go.addEventListener('click', function () {
          go.disabled = true;
          go.textContent = 'Réservation en cours';
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var items = lines.map(function (v) { return { id: parseInt(v.id, 10), quantity: per }; });
              if (feed && feed.preferred && feed.ids && feed.ids.length) {
                var feedIds = feed.ids.map(String);
                var hasFeed = (cart.items || []).some(function (li) { return feedIds.indexOf(String(li.variant_id)) !== -1; });
                if (!hasFeed) items.push({ id: parseInt(feed.preferred.id, 10), quantity: 1 });
              }
              return quizAddItems(items);
            })
            .then(function () {
              try { localStorage.setItem('jp-event-selection', JSON.stringify({ store: chosen, date: label })); } catch (e) { /* noop */ }
              go.textContent = 'Troupeau réservé · voir le panier';
              go.disabled = false;
              go.onclick = null;
              ga('jpc_quiz_add', { flock: breeds.join(','), qty_total: per * lines.length, store: chosen });
            })
            .catch(function () {
              go.disabled = false;
              go.textContent = 'Réessayer';
              if (msg) { msg.hidden = false; msg.textContent = 'Une erreur est survenue. Réessayez ou réservez chaque race sur sa page.'; }
            });
        });
      }
      build();
    }

    var countTmpl = {
      petite: quiz.getAttribute('data-count-petite') || '',
      moyenne: quiz.getAttribute('data-count-moyenne') || '',
      grande: quiz.getAttribute('data-count-grande') || ''
    };

    var answers = { q1: null, q2: null, q3: null };
    var current = 0;
    var total = steps.length;
    var started = false;

    function showStep(idx) {
      steps.forEach(function (s, i) { s.setAttribute('data-active', i === idx ? 'true' : 'false'); });
      if (resultWrap) resultWrap.setAttribute('data-active', 'false');
      if (bar) bar.style.width = ((idx + 1) / total * 100) + '%';
      if (countLabel) countLabel.textContent = (idx + 1) + ' / ' + total;
      if (backBtn) backBtn.disabled = (idx === 0);
      current = idx;
    }

    function buildChips(panel, breeds) {
      var host = panel.querySelector('[data-jpc-chips]');
      if (!host) return;
      host.textContent = '';
      breeds.forEach(function (code) {
        var info = map[code];
        if (!info) return;
        var a = document.createElement('a');
        a.className = 'jpc-quiz__chip';
        a.href = info.url || '#';
        var sw = document.createElement('span');
        sw.className = 'jpc-quiz__chip-swatch';
        sw.setAttribute('aria-hidden', 'true');
        if (info.hex) sw.style.background = info.hex;
        var name = document.createElement('span');
        name.className = 'jpc-quiz__chip-name';
        name.textContent = info.title || code;
        a.appendChild(sw);
        a.appendChild(name);
        if (info.eggs) {
          var eggs = document.createElement('span');
          eggs.className = 'jpc-quiz__chip-eggs';
          eggs.textContent = info.eggs + ' oeufs/an';
          a.appendChild(eggs);
        }
        host.appendChild(a);
      });
    }

    function showResult() {
      var flock = pickFlock(answers);
      quizFlock = flock.breeds;
      var matched = null;
      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-jpc-result') === flock.key;
        panel.style.display = isMatch ? 'block' : 'none';
        if (isMatch) matched = panel;
      });
      if (!matched && panels.length) { matched = panels[panels.length - 1]; matched.style.display = 'block'; }

      var eggNames = [];
      if (matched) {
        buildChips(matched, flock.breeds);
        renderQuizAtc(matched, flock.breeds, answers.q2);
        var countEl = matched.querySelector('[data-jpc-count]');
        if (countEl) {
          var tmpl = countTmpl[answers.q2] || '';
          countEl.textContent = tmpl;
          countEl.hidden = !tmpl;
        }
        var cta = matched.querySelector('[data-jpc-quiz-cta]');
        if (cta) {
          flock.breeds.forEach(function (code) { if (map[code] && map[code].name) eggNames.push(map[code].name); });
          cta.onclick = function (e) {
            e.preventDefault();
            highlightQuizCards(quizFlock, eggNames);
          };
        }
      }

      steps.forEach(function (s) { s.setAttribute('data-active', 'false'); });
      if (resultWrap) resultWrap.setAttribute('data-active', 'true');
      if (bar) bar.style.width = '100%';
      if (live && matched) {
        live.textContent = '';
        setTimeout(function () {
          var h = matched.querySelector('[data-jpc-result-title]');
          if (h) live.textContent = h.textContent;
        }, 60);
      }
      ga('jpc_quiz_complete', { q1: answers.q1, q2: answers.q2, q3: answers.q3, flock: flock.breeds.join(',') });
    }

    quiz.querySelectorAll('[data-jpc-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-jpc-q]');
        if (!step) return;
        var key = step.getAttribute('data-jpc-q'); /* q1 | q2 | q3 */
        answers[key] = btn.getAttribute('data-jpc-val');
        step.querySelectorAll('[data-jpc-val]').forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
        if (!started) { started = true; ga('jpc_quiz_start', {}); }
        setTimeout(function () {
          if (current < total - 1) showStep(current + 1);
          else showResult();
        }, 200);
      });
    });

    if (backBtn) backBtn.addEventListener('click', function () { if (current > 0) showStep(current - 1); });

    quiz.querySelectorAll('[data-jpc-quiz-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers = { q1: null, q2: null, q3: null };
        started = false;
        quizFlock = null;
        clearQuizHighlight();
        quiz.querySelectorAll('[data-jpc-val]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        showStep(0);
      });
    });

    showStep(0);
  }

  /* ---------- 4. Availability matrix link GA ---------- */
  function initMatrixLinks() {
    var links = document.querySelectorAll('[data-jpc-matrix-link]');
    if (!links.length) return;
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        ga('jpc_matrix_click', {
          breed: link.getAttribute('data-breed-code') || '',
          target_url: link.getAttribute('href') || ''
        });
      });
    });
  }

  ready(function () {
    initGridFilters();
    initRainbow();
    initQuiz();
    initMatrixLinks();
  });
})();

/* Event band countdown + GA view on collection pages. Same behaviour as
   jp-pdp.js initEventBand; the data-jp-band-init flag prevents double init
   when both scripts ever share a page. */
(function () {
  'use strict';
  var band = document.querySelector('[data-jp-event-band]');
  if (!band || band.dataset.jpBandInit) return;
  band.dataset.jpBandInit = '1';
  function ga(name, params) {
    if (typeof window.gtag === 'function') { try { window.gtag('event', name, params || {}); } catch (e) { /* noop */ } }
  }
  var gaName = band.getAttribute('data-jp-band-ga') || 'jp_event_band_view';
  var state = (band.className.match(/jpp-eventband--(\w+)/) || [])[1] || '';
  var fired = false;
  function fire() { if (fired) return; fired = true; ga(gaName, { state: state }); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { fire(); io.disconnect(); } });
    }, { threshold: 0.4 });
    io.observe(band);
  } else { fire(); }

  var cd = band.querySelector('[data-jp-band-countdown]');
  if (!cd) return;
  var iso = cd.getAttribute('data-jp-deadline');
  if (!iso) return;
  var end = Date.parse(iso);
  if (isNaN(end)) return;
  var timer = cd.querySelector('[data-jp-band-timer]');
  var elD = cd.querySelector('[data-jp-band-days]');
  var elH = cd.querySelector('[data-jp-band-hours]');
  var elM = cd.querySelector('[data-jp-band-mins]');
  function tick() {
    var diff = end - Date.now();
    if (diff <= 0) { if (timer) timer.hidden = true; cd.classList.add('is-expired'); return false; }
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60);
    if (elD) elD.textContent = d;
    if (elH) elH.textContent = h;
    if (elM) elM.textContent = m;
    if (timer) timer.hidden = false;
    if (diff < 86400000) cd.classList.add('is-urgent');
    return true;
  }
  if (tick() === false) return;
  var t = setInterval(function () { if (tick() === false) clearInterval(t); }, 60000);
})();

/* Mobile sticky reserve/resume bar (collection). Default state anchors to
   the grid; when the cart already holds birds from this collection it
   becomes a resume-your-reservation bar opening the cart drawer. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-jpc-sticky]');
  if (!bar || bar.dataset.jpcStickyInit) return;
  bar.dataset.jpcStickyInit = '1';

  var txt = bar.querySelector('[data-jpc-sticky-txt]');
  var btn = bar.querySelector('[data-jpc-sticky-btn]');

  // Reveal after the hero scrolls out; hide near the footer.
  var hero = document.querySelector('[data-jpc-hero]');
  function onScroll() {
    var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    var nearEnd = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 400);
    bar.setAttribute('data-visible', past && !nearEnd ? 'true' : 'false');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Resume state when the cart already holds birds from this collection.
  var handles = {};
  document.querySelectorAll('[data-jpc-card] a[href*="/products/"]').forEach(function (a) {
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (m) handles[m[1]] = true;
  });
  function toResume(count) {
    if (txt) txt.textContent = 'Votre troupeau vous attend · ' + count + (count > 1 ? ' oiseaux' : ' oiseau');
    if (btn) {
      btn.textContent = 'Voir le panier';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var bubble = document.querySelector('#cart-icon-bubble');
        if (bubble) bubble.click(); else window.location.href = '/cart';
      });
    }
  }
  function checkCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = 0;
        (c.items || []).forEach(function (li) { if (handles[li.handle]) n += li.quantity; });
        if (n > 0) toResume(n);
      })
      .catch(function () { /* noop */ });
  }
  checkCart();
  document.addEventListener('cart:refresh', checkCart);
})();
